module.exports = __webpack_public_path__ + "static/media/crx.bf5801ab.png";